/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{background:#f6f6f6;margin:25px 20px}form[_ngcontent-%COMP%]{padding:16px}textarea[_ngcontent-%COMP%]{min-height:51px}div[_ngcontent-%COMP%]{padding-top:10px}div[_ngcontent-%COMP%]   #title[_ngcontent-%COMP%]{font-weight:700;font-size:1.3em;color:#0a60a9}mat-radio-button[_ngcontent-%COMP%]{margin-right:15px}"];
export { styles as styles };
